import { globals } from "@/utilities/globals";
import axios from "axios";

axios.defaults.baseURL = `${globals.VUE_APP_CENTRAL}/api/`;
